import { useState, useEffect, createContext, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import WindowLocation from 'helpers/windowLocation'
import Environment from 'helpers/environment'

import Api from 'services/api'

const SessionContext = createContext()

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape()
  ]).isRequired
}

export const SessionContextProvider = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigate()

  const [session, setSession] = useState(null)
  const [isUpgraded, setIsUpgraded] = useState(false)
  const [isSessionLoaded, setIsSessionLoaded] = useState(false)

  const tierUpgraded = (oldSession, newSession) => {
    if (!oldSession || !newSession) return false

    const oldTier = oldSession.dealerPlan?.tier
    const newTier = newSession.dealerPlan?.tier
    const inTrial = newSession.dealerPlan?.in_trial

    return oldTier === 'standard' && newTier === 'premium' && inTrial === true
  }

  useEffect(() => {
    Api.Session.get()
      .then((res) => {
        if (JSON.stringify(session) !== JSON.stringify(res)) {
          setSession(res)
          setIsSessionLoaded(true)
          if (tierUpgraded(session, res)) {
            setIsUpgraded(true)
          }
        }
      })
      .catch((err) => {
        if (err.message === 'Unauthorized' || err.message.match(/Server Error/)) {
          if (Environment.isAWSCognito()) {
            navigate('/sign_in_error', { replace: true })
          } else {
            WindowLocation.replace(`${Environment.backendApiURL()}/api/sessions/saml/redirect?path=${encodeURIComponent(location.pathname)}&search=${encodeURIComponent(location.search)}`)
          }
        }

        setIsUpgraded(false)
        setSession(null)
        setIsSessionLoaded(false)
      })
  }, [location.pathname, location.search, session, navigate, isUpgraded])

  return (
    <SessionContext.Provider value={{ session, isSessionLoaded, setIsSessionLoaded, setSession, isUpgraded }}>
      {children}
    </SessionContext.Provider>
  )
}

SessionContextProvider.propTypes = propTypes

export const useSessionContext = () => useContext(SessionContext)
